import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
/**
 * Scrolls the window back to the top whenever the route (pathname) changes.
 * React Router preserves scroll position across navigations by default, which
 * made in-app links (e.g. "Explore the Brossard case study") open a new page
 * still scrolled down. Mounting this inside the Router fixes it app-wide.
 *
 * It intentionally ignores hash changes so on-page anchor links (#section)
 * keep their smooth-scroll behavior.
 */
export function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return null;
}